import { Component, OnInit } from '@angular/core';
import path from 'path';
import { ApiService } from '../../service/api/api.service';
import { log } from 'console';
import { SocketService } from '../../service/sio/socket.service';
import { NotificationService } from '../../service/notification/notification.service';
declare function initialize(): any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  userConneceted: any;

  constructor(public api: ApiService, private sio: SocketService, public not: NotificationService) {

  }
  ngOnInit(): void {
    initialize()
    this.userConneceted = this.api.token.user_connected

    // afficher une notification apres ajout ou modification de commande
    this.sio.on_change("after_add_commande", "after_edit_commande", (data: any) => {
      this.not.showNotification("Commande", "Du nouveau dans les commandes")
    });
    // afficher une notification apres ajout ou modification de livraison
    this.sio.on_change("after_add_livraison", "after_edit_livraison", (data: any) => {
      this.not.showNotification("Livraison", "Du nouveau dans les livraisons")
    });
  }

  logout() {
    this.api.deconnexion();
  }
}
